"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessType = void 0;
exports.BusinessType = {
    SoleProprietorship: "soleProprietorship",
    UnincorporatedAssociation: "unincorporatedAssociation",
    Trust: "trust",
    PublicCorporation: "publicCorporation",
    PrivateCorporation: "privateCorporation",
    Llc: "llc",
    Partnership: "partnership",
    UnincorporatedNonProfit: "unincorporatedNonProfit",
    IncorporatedNonProfit: "incorporatedNonProfit",
};
